import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from "@angular/forms";
import { FuseConfigService } from "@fuse/services/config.service";
import { fuseAnimations } from "@fuse/animations";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthenticationService } from "../../common/service/authentication.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { error } from "console";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "forgot-password-2",
    templateUrl: "./forgot-password.component.html",
    styleUrls: ["./forgot-password.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ForgotPasswordComponent implements OnInit {
    forgotPasswordForm: FormGroup;
    mailSent = false;
    msgColor = "";
    color = ["green", "red", "blue"];
    msg = "";
    spinner = false;
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        public router: Router,
        public snackBar: MatSnackBar,
        public authService: AuthenticationService,
        private translate: TranslateService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.mailSent = false;
        this.forgotPasswordForm = this._formBuilder.group(
            {
                email: [
                    "",
                    [
                        Validators.required,
                        Validators.email,
                        Validators.pattern(
                            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
                        ),
                    ],
                ],
                password: [
                    "",
                    [
                        Validators.required,
                        Validators.minLength(6),
                        Validators.pattern(/^\S*$/),
                    ],
                ],
                confirmPassword: [
                    "",
                    [Validators.required, Validators.pattern(/^\S*$/)],
                ],
            },
            {
                validators: confirmPasswordValidator,
            }
        );
    }

    forgotPassword() {
        this.spinner = true;
        this.authService.resetPassword(this.forgotPasswordForm.value).subscribe(
            (res) => {
                Object.entries(res).find(([key, value]) => {
                    if (key == "data") {
                        this.spinner = false;
                        this.openSnackBar(
                            this.translateSentence("forgotPassword.message1"),
                            this.translateSentence("Common.ok")
                        );
                        this.router.navigate(["/login"]);
                    }
                });
            },
            (error) => {
                this.openSnackBar(error.error.message, "Ok");
                this.spinner = false;
            }
        );
    }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 4000,
        });
    }

    private handleError(error: Error): void {
        this.openSnackBar(error.message, "OK");
        // this.notify.update(error.message, 'error');
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }
}

export const confirmPasswordValidator: ValidatorFn = (
    group: AbstractControl
): ValidationErrors | null => {
    const password = group.get("password");
    const confirmPassword = group.get("confirmPassword");

    if (!password || !confirmPassword) return null;

    if (
        confirmPassword.errors &&
        !confirmPassword.errors["passwordsNotMatching"]
    ) {
        return null;
    }

    if (password.value !== confirmPassword.value) {
        confirmPassword.setErrors({ passwordsNotMatching: true });
    } else {
        confirmPassword.setErrors(null);
    }

    return null;
};
